import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../Layout";
import NewServiceSidebar from "../../components/Services/SingleServiceComponents/NewServiceSideBar";
import BasicDetails from "../../components/Services/SingleServiceComponents/BasicDetails";
import sericesApi from "../../api/service/service.api";
import { ArrowLeft, X } from "lucide-react";
import Loading from "../../Util/Loading";

const EditService = () => {
  const { id } = useParams();
  console.log({ id });
  const [selected, setSelected] = useState("basic");
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        // 1. fetch service detail
        const serviceRes = await sericesApi.getServiceDetail({
          id: id,
        });

        const service = serviceRes;
        // 4. build initial data for Formik
        setInitialData({
          serviceName: service?.title || "",
          description: service?.description || "",
          price: service?.price || "",
          duration: service?.desc || "", // your "desc" is duration
          priceType: service?.priceType || "", // might be missing, fallback
          category: service?.category || null,
        });
      } catch (err) {
        console.error("Error loading service:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const navigate = useNavigate();

  if (loading) return <Loading />;

  return (
    <Layout>
      <div className="p-4 md:p-6 w-full container mx-auto bg-dry min-h-screen">
        <div className="bg-dry text-text rounded-lg shadow p-0 lg:p-6 min-h-screen">
          <div className="flex items-start lg:items-center justify-between mb-6">
            <div className="flex flex-col items-start justify-center">
              <h2 className="text-xl font-semibold text-white mt-6 lg:mt-0">
                Edit Service
              </h2>
              <p className="text-sm">Update a service.</p>
            </div>
            <div className="hidden md:flex gap-2">
              <div className="flex justify-end  p-4">
                <button
                  className="px-4 py-2 rounded-md border border-border mr-2 hover:bg-redlight hover:text-white"
                  onClick={() => navigate(-1)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>

          <button
            onClick={() => navigate(-1)}
            className="md:hidden absolute top-[100px] right-4 text-redlight bg-drylight rounded-xl p-1 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
          <div className="flex rounded-lg shadow min-h-[70vh] gap-3">
            <NewServiceSidebar selected={selected} onSelect={setSelected} />

            <main className="flex-1 pt-3 lg:pt-3 overflow-y-auto">
              {selected === "basic" && (
                <BasicDetails initialData={initialData} isEdit serviceId={id} />
              )}
              {/* keep other tabs same if you want */}
            </main>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default EditService;
